import { BasePayloadMapper } from '@ps/utils';

import { SurveyQuestionsListParams } from '../dtos/survey-question.dto';

// WIP: derive from the survey's selected country/language once wired up (see
// searchLocale in localization-form.component.ts for the `${language.shortCode}_${country.shortCode}`
// formula) — hardcoded per explicit direction for this pass.
const ADVANCED_TARGETING_LOCALE = 'eng_US';

export type SurveyQuestionsListPayload = Record<string, string>;

export class SurveyQuestionsPayloadMapper extends BasePayloadMapper<
  SurveyQuestionsListParams,
  SurveyQuestionsListPayload
> {
  public toPayload(
    params: SurveyQuestionsListParams,
  ): SurveyQuestionsListPayload {
    const payload: SurveyQuestionsListPayload = {
      locale: ADVANCED_TARGETING_LOCALE,
    };
    if (params.search) {
      payload['phrase'] = params.search;
    }
    if (params.categoryIds.length) {
      payload['categories'] = params.categoryIds.join(',');
    }
    return payload;
  }
}
